import { matchPath } from 'react-router-dom'

function isActive(path?: string) {
  const match = matchPath({ path: `${path}` }, window.location.pathname)
  return Boolean(match)
}

export { isActive }
